import { phpClient } from ".";
import {
  ReportData,
  ReportDrilldownResponse,
  ReportRunResponse,
  TimecardAuditDetail,
  TimecardDrilldownParams,
  TimecardNoteDetail,
  TimecardReportParams,
  TimecardViolationDetail,
} from "../types";

const TIMECARD_REPORT_URL = "/reports/run/timecard_activity_report";
const LEGACY_TIMECARD_REPORT_URL = "/reports/run/timecard_report";

function buildTimecardReportParams(params: TimecardReportParams): URLSearchParams {
  const searchParams = new URLSearchParams();

  if (params.date_from) searchParams.set("date_from", params.date_from);
  if (params.date_to) searchParams.set("date_to", params.date_to);
  if (params.site_id) searchParams.set("site_id", String(params.site_id));
  if (params.search?.trim()) searchParams.set("search", params.search.trim());
  searchParams.set("page", String(params.page ?? 1));
  searchParams.set("limit", String(params.limit ?? 20));

  params.department_codes
    ?.filter(Boolean)
    .forEach((code) => searchParams.append("department_code[]", code));

  return searchParams;
}

export async function runTimecardReport(params: TimecardReportParams): Promise<ReportRunResponse<ReportData>> {
  const response = await phpClient.get<ReportRunResponse<ReportData>>({
    url: TIMECARD_REPORT_URL,
    params: buildTimecardReportParams(params),
    cache: { enabled: false },
  });

  if (
    !response.status &&
    /timecard_activity_report.*(invalid|not found|not a report-engine report)/i.test(response.message || "")
  ) {
    return phpClient.get<ReportRunResponse<ReportData>>({
      url: LEGACY_TIMECARD_REPORT_URL,
      params: buildTimecardReportParams(params),
      cache: { enabled: false },
    });
  }

  return response;
}

function buildDrilldownPayload(params: TimecardDrilldownParams) {
  return {
    id: params.id,
    ...(params.employee_id ? { employee_id: params.employee_id } : {}),
  };
}

export async function getTimecardReportNotes(params: TimecardDrilldownParams): Promise<ReportDrilldownResponse<TimecardNoteDetail[]>> {
  return phpClient.post<ReportDrilldownResponse<TimecardNoteDetail[]>>({
    url: "/timecard/get_notes",
    data: buildDrilldownPayload(params),
    cache: { enabled: false },
  });
}

export async function getTimecardReportAudit(params: TimecardDrilldownParams): Promise<ReportDrilldownResponse<TimecardAuditDetail[]>> {
  return phpClient.post<ReportDrilldownResponse<TimecardAuditDetail[]>>({
    url: "/timecard/get_audit",
    data: buildDrilldownPayload(params),
    cache: { enabled: false },
  });
}

export async function getTimecardReportViolations(params: TimecardDrilldownParams): Promise<ReportDrilldownResponse<TimecardViolationDetail[]>> {
  return phpClient.post<ReportDrilldownResponse<TimecardViolationDetail[]>>({
    url: "/timecard/get_violations",
    data: buildDrilldownPayload(params),
    cache: { enabled: false },
  });
}
